<template>
  <div id="app">
    <NavigationHeader />
    <router-view/>
    <NavigationFooter />
  </div>
</template>
<script>
  import NavigationHeader from '@/views/navigation_header/index.vue'
  import NavigationFooter from '@/views/navigation_footer/index.vue'

  export default {
    components: {
      NavigationHeader,
      NavigationFooter
    },
    data() {
      return {
        constants: {}
      };
    },
    methods: {}
  };
</script>
<style lang="css" src="./assets/common.css">
</style>
